import { render, staticRenderFns } from "./ParamHeader.vue?vue&type=template&id=5505e5d1&scoped=true"
import script from "./ParamHeader.vue?vue&type=script&lang=js"
export * from "./ParamHeader.vue?vue&type=script&lang=js"
import style0 from "./ParamHeader.vue?vue&type=style&index=0&id=5505e5d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505e5d1",
  null
  
)

export default component.exports